import _ from 'lodash'
import React from 'react'
import ListingBadge, { BADGE_MODE } from './base'
import FullWidthBadge from './fullWidthBadge'
import { isShortSale, getBrokerAgent } from './utils'

class ShortSaleBadge extends ListingBadge {
  static title = 'Short Sale'

  static titleIcon = 'sign'

  static content = (
    <span>
      This property is part of Auction.com's Short Sale program.{' '}
      <a href='/lp/learn-more/short-sales/' target='_blank'>
        Learn more
      </a>
    </span>
  )

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return badgeMode === BADGE_MODE.EXPANDED && isShortSale(listing)
  }
}

class ShortSaleOpenHousesAvailableBadge extends FullWidthBadge {
  static summary = 'Open Houses Scheduled'

  static titleIcon = 'unlock-alt'

  static shouldBeHoisted = true

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    if (badgeMode === BADGE_MODE.CONDENSED) return false

    const brokerAgent = getBrokerAgent(listing)

    return (
      _.get(listing, 'listing_configuration.interior_access_allowed', true) &&
      _.isPlainObject(brokerAgent) &&
      isShortSale(listing)
    )
  }

  get content() {
    return (
      <>
        For dates and times or to schedule a private showing{' '}
        <a
          onClick={e => this.emitEvent('interior_access_contact_agent', e)}
          data-elm-id='interior_access_contact_agent'
        >
          contact the listing agent
        </a>
        .
      </>
    )
  }
}

export { ShortSaleBadge, ShortSaleOpenHousesAvailableBadge }
